export default __webpack_public_path__ + "static/media/chain.a1ee97fc.svg";